/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsClearClusterPrice } from "../../funcs/llmModelsClearClusterPrice.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ClearClusterPriceRequest$inboundSchema,
};

export const tool$llmModelsClearClusterPrice: ToolDefinition<typeof args> = {
  name: "llm-models-clear-cluster-price",
  description: `Clear a cluster-default model price

Closes the cluster-default price. Active cluster lineage then uses an org override or becomes unpriced ($0).`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsClearClusterPrice(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
